import { on, selectAll, openModal } from 'helpers/dom'

const selectors = {
  TAB_BUTTONS: '[data-tab-id]',
  TAB_CONTENT: '[data-tab-content]',
  TRIGGER_BUTTON_SELECTOR: '[data-slide-id]'
}

const tabButtons = selectAll(selectors.TAB_BUTTONS)
const tabContents = selectAll(selectors.TAB_CONTENT)
const triggerButtons = selectAll(selectors.TRIGGER_BUTTON_SELECTOR)

if (triggerButtons.length > 0) {
  triggerButtons.forEach((item) => {
    on(
      'click',
      (e) => {
        const targetElement = e.target
        if (targetElement.id !== 'MiniCart') {
          openModal('payment-slideout')
          const targetId = targetElement.dataset.slideId
          if (targetId) {
            document.querySelector(`[data-tab-id="${targetId}"]`).click()
          }
        }
      },
      item
    )
  })
}

if (tabButtons.length > 0 && tabContents.length > 0) {
  tabButtons.forEach((item) => {
    on(
      'click',
      (e) => {
        const targetId = e.target.dataset.tabId

        if (targetId) {
          tabButtons.forEach((button) => button.classList.remove('active'))
          tabContents.forEach((content) => content.classList.remove('active'))

          e.target.classList.add('active')
          tabContents.find((content) => content.dataset.tabContent === targetId).classList.add('active')
        }
      },
      item
    )
  })
}
